import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Staff from './pages/Staff';
import Membership from './pages/Membership';
import Newsletter from './pages/Newsletter';
import Events from './pages/Events';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import MissionStatement from './pages/MissionStatement';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App min-h-screen overflow-x-hidden bg-[#f7f8fa]">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mission-statement" element={<MissionStatement />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/events" element={<Events />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
